import Flatpickr from 'flatpickr';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import moment from 'moment';

import { ExpositionConsumer } from '../data/expositions/exposition';
import { FakeControl } from '../components/form';
import Buttons from './exposition/buttons';
import CalculatePrices from './exposition/prices';

const EXTRA_MONTHS = 12; // How many months should be queried in 1 go.
const EXTRA_TIMES_RUN = 2; // How many times it should run minus the initial run.
const STOP_AT = EXTRA_MONTHS * EXTRA_TIMES_RUN;

Flatpickr.localize(Dutch);


class Expositions {
    constructor() {
        this.fakeControl = new FakeControl();
        this.ticketForm = document.getElementById('ticket-form');
        this.timeSelect = document.getElementById('time-select');
        this.dateField = document.getElementById('id_date');

        this.expositionConsumer = new ExpositionConsumer();
        this._exposition = null;

        if(this.ticketForm && this.dateField) {
            this.selectFirstAvailableDate(0).then((expositions) => {
                this._exposition = expositions;
                let date = expositions.exposition_periods[0].date;
                if(this.dateField.value) {
                    date = this.dateField.value;
                }

                this.renderTicketForm(date);
                this.processExpositionData();
            }).catch((error) => {
                console.exception(error)
                // this._exposition = {
                //     exposition_periods: []
                // };
                // let date = moment().format('YYYY-MM-DD');
                // if(this.dateField.value) {
                //     date = this.dateField.value;
                // }

                // this.renderTicketForm(date);
                // this.processExpositionData();
            });
        }
    }

    addNotification(text) {
        const notification = document.createElement('div');
        notification.classList.add('notification');
        notification.classList.add('notification--error');
        notification.innerText = text;
        this.ticketForm.insertBefore(notification, this.ticketForm.firstChild);
    }

    selectFirstAvailableDate(extra_months) {
        const today = moment().add(extra_months, 'months');
        const month = today.format('YYYY-MM');

        return new Promise((resolve, reject) => {
            if(extra_months >= STOP_AT) {
                this.addNotification(this.dateField.parentElement.dataset.message);
                reject('no first date found');
                return;
            }
            this.expositionConsumer.getExpositionPeriods(this.ticketForm.dataset.guid, month, EXTRA_MONTHS)
            .then((data) => {
                resolve(data);
            })
            .catch((error) => {
                console.error(error); // jshint ignore:line
                reject();
            });
        })
        .then((expositions) => {
            if(expositions.exposition_periods.length >= 1) {
                return expositions;
            } else {
                return this.selectFirstAvailableDate(extra_months+EXTRA_MONTHS);
            }
        });
    }

    renderTicketForm(date) {
        this.flatpickr = new Flatpickr(this.dateField, {
            altFormat: 'd-m-Y',
            defaultDate: date,
            onMonthChange: (selectDates, dateStr, instance) => {
                /*jshint unused: false */
                this.retrieveMonth(instance);
            },
            inline: true,
            enabled: [(date) => false], // jshint ignore:line
            dateFormat: 'Y-m-d',
            minDate: moment().format('d-m-Y'),
            locale: Dutch
        });

        this.dateField.onchange = () => this.dateChange();

        // Fire the change event. So now the periods should show.
        this.dateChange();
    }

    retrieveMonth(instance) {
        const month = instance.currentYear  + '-' + (instance.currentMonth + 1);
        this.expositionConsumer.getExpositionPeriods(this.ticketForm.dataset.guid, month)
            .then(this.processExpositionData.bind(this))
            .catch(console.error);  // jshint ignore:line
    }

    getDateMap() {
        let date_map = {};
        if(this._exposition && this._exposition.exposition_periods.length > 0){
            this._exposition.exposition_periods.forEach((period) => {
                date_map[period.date] = period.availability;
            });
        }
        return date_map;
    }

    processExpositionData() {
        let enabled = [];
        let sold_out = [];
        if(this._exposition && this._exposition.exposition_periods.length > 0){
            this._exposition.exposition_periods.forEach((period) => {
                moment.locale('nl');
                let pd = moment(period.date);
                if(period.sold_out){
                    sold_out.push(pd.format("MMMM D, YYYY"));
                } else {
                    enabled.push((new Date(pd.year(), pd.month(), pd.date())).getTime());
                }
            });
        }

        this.flatpickr.config.enable = [(date) => {
            return enabled.indexOf(date.getTime()) > -1
        }];
        this.flatpickr.redraw();

        for(let sold_item of sold_out) {
            let date_selector = document.querySelector(`[aria-label="${sold_item}"]`);
            date_selector.classList.add('sold_out');
        }

        const periodGuidInput = document.querySelector('#id_exposition_period_guid');
        const toSelect = document.querySelector(`#id_${periodGuidInput.value}`);
        if(toSelect) {
            toSelect.checked = true;
        }
    }

    dateChange() {
        const periodGuidInput = document.querySelector('#id_exposition_period_guid');
        if (periodGuidInput.dataset.changed === "true") {
            this.setExpositionPeriodGuid('');
        }
        let date_map = this.getDateMap();
        const selectDate = moment(this.flatpickr.selectedDates[0]).add(4, 'hours');
        const availability = date_map[selectDate.format('YYYY-MM-DD')];

        if (availability) {
            this.timeSelect.innerHTML = '';
            availability.forEach((period) => {
                const radio_el = document.createElement('input');
                radio_el.classList.add('radio');
                radio_el.setAttribute('name', 'temp_exposition_period_guid');
                radio_el.setAttribute('type', 'radio');
                radio_el.setAttribute('id', 'id_' + period.exposition_period);
                radio_el.setAttribute('value', period.exposition_period);
                radio_el.addEventListener('change', (event) => this.setExpositionPeriodGuid(event.currentTarget.value));

                if(availability.length === 1) {
                    radio_el.setAttribute('checked', true);
                    this.setExpositionPeriodGuid(period.exposition_period);
                }

                const radio_container = document.createElement('div');
                radio_container.classList.add('radio-container');
                radio_container.appendChild(radio_el);
                this.timeSelect.appendChild(radio_container);

                this.fakeControl.addStyling(radio_el);

                const label_el = document.createElement('label');
                label_el.setAttribute('class', 'label label--inline');
                label_el.setAttribute('for', 'id_' + period.exposition_period);
                radio_container.appendChild(label_el);
                const label_text = document.createTextNode(period.description);
                label_el.appendChild(label_text);
            });
        }
        this.processExpositionData();
    }

    setExpositionPeriodGuid(value) {
        const periodGuidInput = document.querySelector('#id_exposition_period_guid');
        periodGuidInput.value = value;
        periodGuidInput.dataset.changed = true;
    }
}

new Expositions();
new Buttons();
new CalculatePrices();



// WEBPACK FOOTER //
// ./src/my_artis/js/views/expositions.js